<template>
  <div class="rounded bg-white p-5">
    <XHeader title="Error" />

    <div>
      <div v-if="isNotFound">
        <span class="mb-8 block">{{ $t('common.confirmInvitation.sections.error.notFound.text') }}</span>
        <small class="block mb-6">{{ $t('common.confirmInvitation.sections.error.notFound.verificationCode', { code: confirmationCode }) }}</small>
      </div>
      <div v-else>
        <span class="block mb-6">{{ $t('common.confirmInvitation.sections.error.server.text') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import XHeader from './common/Header'

export default {
  components: {
    XHeader
  },

  props: {
    errors: {
      type: Array | Object,
      required: true
    },
    confirmationCode: {
      type: String
    }
  },

  computed: {
    isNotFound () {
      return this.errors.length > 0 && this.errors[0].extensions.category === 'notFound'
    }
  }
}
</script>
